export const processRedMarkers = (text) => {
    if (!text) return '';
    return text.replace(/\[RED\](.*?)\[\/RED\]/g, '<span @if($show_clues)="" style="border: solid red 2px;" @endif="">$1</span>');
};

export const getAvailableBlocks = () => [
    {
        type: 'header',
        name: 'Header',
        description: 'Bedrijfsnaam en logo',
        icon: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm2 0h12v2H4V6z" clip-rule="evenodd"/></svg>'
    },
    {
        type: 'text',
        name: 'Tekst',
        description: 'Tekst inhoud met titel',
        icon: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"/></svg>'
    },
    {
        type: 'button',
        name: 'Knop',
        description: 'Call-to-action knop',
        icon: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V8zm0 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2z" clip-rule="evenodd"/></svg>'
    },
    {
        type: 'image',
        name: 'Afbeelding',
        description: 'Afbeelding met alt tekst',
        icon: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd"/></svg>'
    },
    {
        type: 'spacer',
        name: 'Spatie',
        description: 'Lege ruimte',
        icon: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 16a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"/></svg>'
    },
    {
        type: 'divider',
        name: 'Lijn',
        description: 'Horizontale lijn',
        icon: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"/></svg>'
    },
    {
        type: 'alert',
        name: 'Alert',
        description: 'Waarschuwing of info blok',
        icon: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>'
    },
    {
        type: 'footer',
        name: 'Footer',
        description: 'Footer met contactinfo',
        icon: '<svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M2 12a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm2 0h12v2H4v-2z" clip-rule="evenodd"/></svg>'
    }
];

export const getDefaultBlockData = (type) => {
    const component = componentRegistry[type];
    if (component && component.methods && component.methods.getDefaultData) {
        return component.methods.getDefaultData();
    }
    return {};
};

import TextBlock from './TextBlock.vue';
import ButtonBlock from './ButtonBlock.vue';
import ImageBlock from './ImageBlock.vue';
import SpacerBlock from './SpacerBlock.vue';
import HeaderBlock from './HeaderBlock.vue';
import DividerBlock from './DividerBlock.vue';
import AlertBlock from './AlertBlock.vue';
import FooterBlock from './FooterBlock.vue';

const componentRegistry = {
    text: TextBlock,
    button: ButtonBlock,
    image: ImageBlock,
    spacer: SpacerBlock,
    header: HeaderBlock,
    divider: DividerBlock,
    alert: AlertBlock,
    footer: FooterBlock,
};

export const generateBlockHTML = (type, data) => {
    const component = componentRegistry[type];
    if (component && component.methods && component.methods.generateHTML) {
        const tempInstance = { 
            data,
            processRedMarkers: (component.methods && component.methods.processRedMarkers) 
                ? component.methods.processRedMarkers.bind({ data })
                : processRedMarkers
        };
        return component.methods.generateHTML.call(tempInstance);
    }
    return '';
};